'use client';

import { useSearchParams } from 'next/navigation';
import { useMemo } from 'react';
import { parseTripPlannerEntryContext } from '@alltrails/layout/utils/tripPlannerEntryParams';
import type { TripPlannerEntryAttributes } from '@/utils/tripPlannerAnalytics';

const useTripPlannerEntryContext = (): TripPlannerEntryAttributes => {
  const searchParams = useSearchParams();

  return useMemo(() => {
    const { entryPoint, locationId, parkId } = parseTripPlannerEntryContext(key => searchParams?.get(key));
    return { entry_point: entryPoint, location_id: locationId, park_id: parkId };
  }, [searchParams]);
};

export default useTripPlannerEntryContext;
